import React from 'react';
import PageHeader from './global-components/page-header';
import BlogDetails from './blog-components/blog-details';

const BlogDetailsPage = () => {
    return <div>
        <PageHeader headertitle="Blog Details"  />
        <BlogDetails />
    </div>
}

export default BlogDetailsPage

